const styles = (theme) => ({
  root: {
    '& .CardIcon': {
      color: theme.palette.custom.maintenance,
      backgroundColor: theme.palette.background.lighter,
    },
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
});

export default styles;
